import {Directive, Input, OnChanges} from "@angular/core";
import {CssVarHelper} from "./css-var.helper";

@Directive({
    selector: "[woa-global-css-var]"
})
export class GlobalCssVarDirective implements OnChanges {
    @Input("woa-global-css-var") cssVars: any = {};

    ngOnChanges() {
        CssVarHelper.applyVars(document.documentElement, this.cssVars);
    }
}



// WEBPACK FOOTER //
// ./src/app/html-utils/global-css-var.directive.ts